// Apple Input Style Overrides
// ─────────────────────────────────────────────────────────────────────────────

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: 'rgba(60,60,67,0.18)',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: '10px 10px 0 0',
          backgroundColor: 'rgba(120,120,128,0.12)',
          height: 44,
          '&.MuiInputBase-multiline': { height: 'auto' },
          '&:hover': {
            backgroundColor: 'rgba(120,120,128,0.16)',
          },
          '&.Mui-focused': {
            backgroundColor: 'rgba(0,122,255,0.06)',
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(120,120,128,0.12)',
          },
        },
        underline: {
          '&:before': {
            borderBottomColor: 'rgba(60,60,67,0.18)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          height: 44,
          '&.MuiInputBase-multiline': { height: 'auto' },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(60,60,67,0.18)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(60,60,67,0.25)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#007AFF',
            borderWidth: 1,
          },
          '&.Mui-focused': {
            boxShadow: '0 0 0 3px rgba(0,122,255,0.15)',
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(60,60,67,0.12)',
            },
          },
        },
      },
    },
  };
}
